import React from 'react';
import styled from 'styled-components';

const ProjectOutline = ({ tag, heading, description, background }) => {
  return (
    <Container style={{ background }}>
      <div className='box-tag'>{tag}</div>
      <div className='box-heading'>
        {heading.map((head) => (
          <div key={head}>{head}</div>
        ))}
      </div>
      <div className='box-detail'>
        <p className='box-description'>{description}</p>
      </div>
    </Container>
  );
};

const Container = styled.div`
  grid-column: span 2;
  background-color: #181725;
  border-radius: 25px;
  text-align: left;
  padding: 40px;

  .box-tag {
    margin-bottom: 80px;
    color: #fff;
    font-size: 19px;
    font-weight: 600;
  }

  .box-heading {
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 24px;
  }

  .box-detail {
    font-size: 19px;

    .box-description {
      color: #fff;
      margin-bottom: 8px;
    }
  }

  @media only screen and (min-width: 769px) {
    grid-column: span 1;
  }

  @media only screen and (min-width: 1025px) {
  }
`;

export default ProjectOutline;
